/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { InfoDto } from '../models/info-dto';

@Injectable({
  providedIn: 'root',
})
export class UserService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation loadUserInfo
   */
  static readonly LoadUserInfoPath = '/info';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `loadUserInfo()` instead.
   *
   * This method doesn't expect any request body.
   */
  loadUserInfo$Response(params?: {
  }): Observable<StrictHttpResponse<InfoDto>> {

    const rb = new RequestBuilder(this.rootUrl, UserService.LoadUserInfoPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<InfoDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `loadUserInfo$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  loadUserInfo(params?: {
  }): Observable<InfoDto> {

    return this.loadUserInfo$Response(params).pipe(
      map((r: StrictHttpResponse<InfoDto>) => r.body as InfoDto)
    );
  }

}
